import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import svgPaths from "./svg-paths.js";
import { SectionHeader } from "./SectionHeader.jsx";

const techStackData = [
  {
    category: "Design",
    title: "Figma",
    description: "Prototyping /UI Design",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d={svgPaths.p165e2c00}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.p2f6e8c0}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.p32c0b4c0}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    category: "Front-End",
    title: "ReactJS",
    description: "Interactive Dashboard",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d="M16 18L22 12L16 6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M8 6L2 12L8 18"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    category: "Back-End",
    title: "Flask / FastAPI",
    description: "API Logic",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d={svgPaths.pc21c880}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.p138a0cf0}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M6 6H6.01"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M6 18H6.01"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    category: "AI Models",
    title: "OpenAI GPT-4, TensorFlow Keras",
    description: "NLP & Behavioral Prediction",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d="M12 20V22"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M12 2V4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M17 20V22"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M17 2V4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M2 12H4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M2 17H4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M2 7H4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M20 12H22"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M20 17H22"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M20 7H22"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M7 20V22"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M7 2V4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.pc216af0}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.p10ba7d80}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    category: "Cloud",
    title: "AWS Lambda + S3",
    description: "Scalability & Storage",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d={svgPaths.p22bef200}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    category: "Database",
    title: "PostgreSQL + MongoDB",
    description: "Structured & Unstructured Data",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d={svgPaths.p11feba00}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.p1b1afa80}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d={svgPaths.p3eed8380}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    category: "Analytics",
    title: "Python (Pandas, Matplotlib)",
    description: "Visualization and Reports",
    icon: (
      <svg className="block size-full" fill="none" viewBox="0 0 24 24">
        <path
          d="M5 21V15"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M12 21V3"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M19 21V9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    ),
  },
];

const techBadges = [
  "React",
  "Flask API",
  "AWS Lambda",
  "OpenAI",
  "TensorFlow",
  "PostgreSQL",
];

function TechStackItem({ icon, category, title, description, index }) {
  const itemRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: itemRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [50, -50]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      ref={itemRef}
      style={{ y, opacity }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, margin: "-100px" }}
      transition={{
        duration: 0.6,
        delay: index * 0.1,
        ease: [0.25, 0.4, 0.25, 1],
      }}
      whileHover={{
        scale: 1.02,
        transition: { duration: 0.2 },
      }}
      className="relative bg-[rgba(16,24,40,0.7)] backdrop-blur-sm rounded-[14px] item-border border-[#1e2939] p-6 md:p-8"
    >
      {/* Icon */}
      <motion.div
        className="w-12 h-12 bg-[rgba(253,91,56,0.1)] rounded-[10px] flex items-center justify-center mb-6 text-[#fd5b38]"
        whileHover={{
          scale: 1.1,
          backgroundColor: "rgba(253,91,56,0.2)",
          transition: { duration: 0.2 },
        }}
      >
        <div className="w-6 h-6">{icon}</div>
      </motion.div>

      {/* Content */}
      <div className="space-y-4">
        <motion.p
          className="text-[#fd5b38]"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: false }}
          transition={{ delay: index * 0.1 + 0.2 }}
        >
          {category}
        </motion.p>

        <motion.h3
          className="text-white text-lg"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: false }}
          transition={{ delay: index * 0.1 + 0.3 }}
        >
          {title}
        </motion.h3>

        <motion.p
          className="text-[#99a1af]"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: false }}
          transition={{ delay: index * 0.1 + 0.4 }}
        >
          {description}
        </motion.p>
      </div>
    </motion.div>
  );
}

function ArchitectureDiagram() {
  const diagramRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: diagramRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [30, -30]);

  return (
    <motion.div
      ref={diagramRef}
      style={{ y }}
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: false, margin: "-100px" }}
      transition={{ duration: 0.8 }}
      className="relative bg-[rgba(16,24,40,0.5)] backdrop-blur-sm rounded-[14px] item-border border-[#1e2939] p-6 md:p-8"
    >
      {/* Title */}
      <motion.p
        className="text-[#6a7282] text-sm text-center mb-6"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ delay: 0.2 }}
      >
        System Architecture Overview
      </motion.p>

      {/* Tech badges */}
      <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8">
        {techBadges.map((badge, index) => (
          <motion.div
            key={badge}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false }}
            transition={{ delay: index * 0.1 }}
            whileHover={{
              scale: 1.05,
              backgroundColor: "rgba(253,91,56,0.2)",
              borderColor: "rgba(253,91,56,0.5)",
              transition: { duration: 0.2 },
            }}
            className="bg-[rgba(253,91,56,0.1)] item-border border-[rgba(253,91,56,0.3)] rounded-[10px] px-4 py-2 text-[#d1d5dc] text-sm whitespace-nowrap"
          >
            {badge}
          </motion.div>
        ))}
      </div>

      {/* Connection diagram */}
      <motion.div
        className="flex items-center justify-center h-20 md:h-24 opacity-30"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 0.3 }}
        viewport={{ once: false }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        <svg
          className="w-full max-w-3xl h-full"
          fill="none"
          viewBox="0 0 988.8 123.6"
          preserveAspectRatio="xMidYMid meet"
        >
          <g opacity="1">
            <motion.path
              d="M123.6 61.8H865.2"
              stroke="#FD5B38"
              strokeDasharray="6.18 6.18"
              strokeWidth="2.472"
              initial={{ pathLength: 0 }}
              whileInView={{ pathLength: 1 }}
              viewport={{ once: false }}
              transition={{ duration: 2, ease: "easeInOut" }}
            />
            {[
              svgPaths.p2fcde00,
              svgPaths.p63ae900,
              svgPaths.p2d1bd00,
              svgPaths.p17458b00,
              svgPaths.p1f308800,
            ].map((path, index) => (
              <motion.path
                key={index}
                d={path}
                fill="#FD5B38"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: false }}
                transition={{ delay: 0.5 + index * 0.1 }}
              />
            ))}
          </g>
        </svg>
      </motion.div>
    </motion.div>
  );
}

export function TechStackSection() {
  const sectionRef = useRef(null);

  return (
    <section
      ref={sectionRef}
      className="relative py-16 md:py-24 lg:py-32 overflow-hidden"
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <SectionHeader
          number="12"
          title="Technology Stack and Infrastructure"
        />

        {/* Main container with background gradient */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative mt-4 rounded-[16px] item-border border-[#1e2939] p-6 md:p-10 lg:p-12"
          style={{
            backgroundImage:
              "linear-gradient(116.019deg, rgba(16, 24, 40, 0.5) 0%, rgba(16, 24, 40, 0.3) 100%)",
          }}
        >
          {/* Tech stack grid */}
          <div className="grid grid-cols-1 gap-4 md:gap-6 mb-8 md:mb-12">
            {techStackData.map((item, index) => (
              <TechStackItem
                key={item.category}
                icon={item.icon}
                category={item.category}
                title={item.title}
                description={item.description}
                index={index}
              />
            ))}
          </div>

          {/* Architecture diagram */}
          <ArchitectureDiagram />
        </motion.div>
      </div>
    </section>
  );
}
